export default __webpack_public_path__ + "static/media/shopify-section-5.3f4fc90c.svg";